module.exports = __webpack_public_path__ + "media/images/corchos-de7c3f8ae7555d5285e37b0f27df9637.jpg";